import Vue from 'vue';

Vue.component('tab-component', {
    data() {
        return {
            tabIndex: 0,
        };
    },

    mounted() {
        // Add keydown event listener for keyboard navigation
        this.$nextTick(() => {
            const tablist = this.$el.querySelector('[role="tablist"]');
            if (tablist) {
                tablist.addEventListener('keydown', this.handleTablistKeydown);
            }
        });
    },

    beforeDestroy() {
        // Clean up event listener
        const tablist = this.$el.querySelector('[role="tablist"]');
        if (tablist) {
            tablist.removeEventListener('keydown', this.handleTablistKeydown);
        }
    },

    methods: {
        switchTab(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
                // Focus the selected tab when switched programmatically
                this.$nextTick(() => {
                    const tabs = this.$el.querySelectorAll('[role="tab"]');
                    if (tabs && tabs[index]) {
                        tabs[index].focus();
                    }
                });
            }
        },

        handleTablistKeydown(e) {
            const tabs = Array.from(this.$el.querySelectorAll('[role="tab"]'));
            const currentIndex = tabs.findIndex(
                (tab) => tab === document.activeElement,
            );

            if (currentIndex === -1) return;

            let nextIndex;
            switch (e.key) {
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    nextIndex = (currentIndex + 1) % tabs.length;
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                    break;
                case 'Home':
                    e.preventDefault();
                    nextIndex = 0;
                    break;
                case 'End':
                    e.preventDefault();
                    nextIndex = tabs.length - 1;
                    break;
                case 'Enter':
                case ' ': // Space key
                    e.preventDefault();
                    this.switchTab(currentIndex);
                    return;
                default:
                    return;
            }

            tabs[nextIndex].focus();
        },

        changeTabContainerClass(index) {
            return index === this.tabIndex ? 'tab__container-item--active' : '';
        },

        toggleHomepageSwitcherClass(index) {
            return this.tabIndex === index
                ? 'homepage__switcher-item--active'
                : '';
        },
    },
});
